<template>
  <section class="m-l-10">
    <component :is="component" :table-filter="tableFilter" />
  </section>
</template>

<script>
import CustomTableFilter from '/@/modules/core/table/components/CustomTableFilter.vue';
import DateTableFilter from '/@/modules/core/table/components/DateTableFilter.vue';
import EnumTableFilter from '/@/modules/core/table/components/EnumTableFilter.vue';
import RangeTableFilter from '/@/modules/core/table/components/RangeTableFilter.vue';
import TextTableFilter from '/@/modules/core/table/components/TextTableFilter.vue';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'TableFilter',
  components: {
    CustomTableFilter,
    RangeTableFilter,
    EnumTableFilter,
    DateTableFilter,
    TextTableFilter
  },
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    }
  },
  computed: {
    component() {
      if (this.tableFilter.isCustom) {
        return this.tableFilter.customTableFilter.component
          ? this.tableFilter.customTableFilter.component
          : CustomTableFilter;
      }
      if (this.tableFilter.column.isDate) {
        return DateTableFilter;
      }
      if (this.tableFilter.column.isEnum) {
        return EnumTableFilter;
      }
      if (this.tableFilter.column.isNumeric) {
        return RangeTableFilter;
      }
      if (this.tableFilter.column.isString) {
        return TextTableFilter;
      }
      return null;
    }
  }
};
</script>
